import {
  USER_ORG_USER_FETCH_ERROR,
  USER_ORG_USER_FETCH_SUCCESS,
  USER_ORG_USER_RESET,
} from 'constants/ActionTypes';

export const userOrgUserFetchSuccess = user => ({
  type: USER_ORG_USER_FETCH_SUCCESS,
  payload: user,
});

export const userOrgUserFetchError = error => ({
  type: USER_ORG_USER_FETCH_ERROR,
  payload: error,
});

export const userOrgUserReset = () => ({
  type: USER_ORG_USER_RESET,
  payload: null,
});

